export const pinterest = [
  {
    rank: 1,
    name: "Pinterest",
    description: "无法翻译",
    image: "https://i.pinimg.com/736x/7d/db/58/7ddb5801848392a465eb6669e02c7353.jpg",
    url: "https://i.pinimg.com/736x/7d/db/58/7ddb5801848392a465eb6669e02c7353.jpg",
  },
  {
    rank: 2,
    name: "Pinterest",
    description: "无法翻译",
    image: "https://i.pinimg.com/1200x/ea/08/0a/ea080a82a0570f93ebc0870e87659319.jpg",
    url: "https://i.pinimg.com/1200x/ea/08/0a/ea080a82a0570f93ebc0870e87659319.jpg",
  },
  {
    rank: 3,
    name: "Pinterest",
    description: "无法翻译",
    image: "https://i.pinimg.com/1200x/d2/7a/ad/d27aad98b43942dc5ac2f9ce1b8e8052.jpg",
    url: "https://i.pinimg.com/1200x/d2/7a/ad/d27aad98b43942dc5ac2f9ce1b8e8052.jpg",
  },
  {
    rank: 4,
    name: "Pinterest",
    description: "无法翻译",
    image: "https://i.pinimg.com/736x/c2/d2/bf/c2d2bf08e8df85afd0c570af1dbc7f14.jpg",
    url: "https://i.pinimg.com/736x/c2/d2/bf/c2d2bf08e8df85afd0c570af1dbc7f14.jpg",
  },
  {
    rank: 5,
    name: "Pinterest",
    description: "无法翻译",
    image: "https://i.pinimg.com/736x/ae/b5/61/aeb561857c0f4aa53c96d781968c5603.jpg",
    url: "https://i.pinimg.com/736x/ae/b5/61/aeb561857c0f4aa53c96d781968c5603.jpg",
  },
  {
    rank: 6,
    name: "Pinterest",
    description: "无法翻译",
    image: "https://i.pinimg.com/736x/b2/99/3e/b2993e961fcaea47f9bc74f7d56d9fc7.jpg",
    url: "https://i.pinimg.com/736x/b2/99/3e/b2993e961fcaea47f9bc74f7d56d9fc7.jpg",
  },
];
